<template>
  <div class="home">
    <UserList />
    <mars-map :url="configUrl" @onload="onMapload" :options="options" />
  </div>
</template>

<script>
import request from "@/utils/request";
import MarsMap from "@/components/MarsWork/index.vue";
import UserList from "./components/UserList.vue";

export default {
  name: "HomeView",
  components: {
    MarsMap,
    UserList,
  },
  data() {
    const basePathUrl = window.basePathUrl || "";
    return {
      configUrl: basePathUrl + "config/config.json",
      list: [],
      listQuery: {
        pageInfo: {
          pageSize: 20,
          page: 1,
          totalCount: 0,
        },
        beginTime: "",
        endTime: "",
      },
      pointUserList: [],
      options: {},
      requestTime: 10,
    };
  },
  mounted() {
    var self = this;

    setInterval(() => {
      self.getPointList();
    }, this.requestTime * 1000);
  },
  methods: {
    onMapload(map) {
      var self = this;
      this.map = map;
      // 以下为演示代码
      map.setCameraView({
        lat: 31.056823,
        lng: 121.763854,
        alt: 2667,
        heading: 6,
        pitch: -83.8,
      });

      map.changeMouseModel(true);
      // map.unbindContextMenu();
      // 限定视角范围
      // var cameraHistory = new mars3d.thing.CameraHistory({
      //   limit: {
      //     position: Cesium.Cartesian3.fromDegrees(117.077104, 31.659094),
      //     radius: 300.0,
      //     debugExtent: false
      //   },
      //   maxCacheCount: 999
      // })
      // map.addThing(cameraHistory)

      // 创建用户图层
      const userLayer = new mars3d.layer.GraphicLayer();
      this.userLayer = userLayer;
      map.addLayer(userLayer);

      // 动态获取人员位置
      this.getPointList();

      // 电子围栏
      this.getRailList();
    },
    getPointList() {
      var self = this;

      request
        .get("/User/Location/Get")
        .then((res) => {
          var data = res.data.data;
          // data.forEach((e, index) => {

          //   // 判断是否已存在
          //   if (self.pointUserList.length > index) {
          //     // 移动到新的位置
          //     self.personMove(self.pointUserList[index], e);
          //   } else {
          //     var graphic = self.addPerson(e);
          //     self.pointUserList.push(graphic);
          //     // self.personMove(graphic, e);
          //   }
          // });

          // 判断是否已存在
          if (self.pointUserList.length > 0) {
            // 移动到新的位置
            self.personMove(self.pointUserList[0], data);
          } else {
            var graphic = self.addPerson(data);
            self.pointUserList.push(graphic);
          }
        })
        .catch(() => {});
    },
    // 移动
    personMove(graphic, item) {
      graphic.addDynamicPosition(
        new mars3d.LngLatPoint(item.longitude, item.latitude, 1),
        10
      );
    },
    addPerson(item) {
      const graphic = new mars3d.graphic.BillboardEntity({
        position: [item.longitude, item.latitude, 0],
        style: {
          image: "img/worker.png",
          scale: 0.6,
          horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
          verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
          label: {
            text: item.userName,
            font_size: 13,
            color: "#ff0000",
            pixelOffsetY: -60,
            distanceDisplayCondition: true,
            distanceDisplayCondition_far: 500000,
            distanceDisplayCondition_near: 0,
          },
        },
        attr: item,
      });
      this.userLayer.addGraphic(graphic);

      return graphic;
    },
    getPersonList() {
      var laoding = this.$loading();
      request
        .post("/User/Location/Query", this.listQuery)
        .then((res) => {
          this.list = res.data.data.data;
          laoding.close();
        })
        .catch(() => {
          laoding.close();
        });
    },
    // 获取电子围栏
    getRailList() {
      request.get("/User/RailInfo/GetList").then((res) => {
        // console.log(res);
        // this.list = res.data.data;
      });
    },
  },
  beforeDestroy() {
    this.map = null;

    this.userLayer.destroy(); //销毁
    this.userLayer = null;
  },
};
</script>

<style lang="scss" scoped>
.home {
  margin: 0;
  padding: 0;
  overflow: hidden;
  width: 100%;
  height: 100%;
}
</style>